export default "__VITE_ASSET__CN58zz$6__"